import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabsContentPrimitive, TabsPrimitive, useB3Config, useModalStore } from "../../../../global-account/react/index.js";
import BottomNavigation from "./BottomNavigation.js";
import { HomeContent } from "./HomeContent.js";
import SettingsContent from "./SettingsContent.js";
export function ManageAccount(t0) {
  const $ = _c(15);
  const {
    onLogout,
    chain,
    partnerId,
    showSwap,
    showDeposit
  } = t0;
  const {
    authStrategy
  } = useB3Config();
  const isBetterAuth = authStrategy === "better-auth";
  const contentType = useModalStore(_temp);
  const {
    activeTab: t1,
    setActiveTab
  } = contentType;
  const activeTab = t1 === undefined ? "home" : t1;
  const setB3ModalContentType = useModalStore(_temp2);
  if (isBetterAuth) {
    let t2;
    if ($[0] !== chain || $[1] !== onLogout || $[2] !== partnerId) {
      t2 = _jsx("div", {
        className: "b3-manage-account flex-1",
        children: _jsx(SettingsContent, {
          partnerId,
          onLogout,
          chain
        })
      });
      $[0] = chain;
      $[1] = onLogout;
      $[2] = partnerId;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== setActiveTab || $[5] !== setB3ModalContentType) {
    t2 = value => {
      const tab = value;
      if (tab === "swap") {
        setB3ModalContentType({
          type: "anySpend",
          showBackButton: true
        });
      } else {
        if (["home", "tokens", "nfts", "apps", "settings"].includes(tab)) {
          setActiveTab?.(tab);
        }
      }
    };
    $[4] = setActiveTab;
    $[5] = setB3ModalContentType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== activeTab || $[8] !== chain || $[9] !== onLogout || $[10] !== partnerId || $[11] !== showDeposit || $[12] !== showSwap || $[13] !== t2) {
    t3 = _jsx("div", {
      className: "b3-manage-account flex-1",
      children: _jsxs(TabsPrimitive, {
        defaultValue: activeTab,
        onValueChange: t2,
        children: [_jsxs("div", {
          className: "p-0",
          children: [_jsx(TabsContentPrimitive, {
            value: "home",
            className: "m-0 p-0 pb-2",
            children: _jsx(HomeContent, {
              showDeposit,
              showSwap
            })
          }), _jsx(TabsContentPrimitive, {
            value: "swap",
            className: "hidden"
          }), _jsx(TabsContentPrimitive, {
            value: "settings",
            className: "m-0 p-0 pb-2",
            children: _jsx(SettingsContent, {
              partnerId,
              onLogout,
              chain
            })
          })]
        }), _jsx(BottomNavigation, {})]
      })
    });
    $[7] = activeTab;
    $[8] = chain;
    $[9] = onLogout;
    $[10] = partnerId;
    $[11] = showDeposit;
    $[12] = showSwap;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
function _temp2(state_0) {
  return state_0.setB3ModalContentType;
}
function _temp(state) {
  return state.contentType;
}